import { Middleware, UnknownAction } from '@reduxjs/toolkit';
import { LevelType } from 'data/types';
import {
  reconcileSpaceWallsRequested,
  wallReconcileRequestsFor
} from './structure-reconcile-actions';
import { SpaceWallReconcileRequestType } from './structure-reconcile-types';
import { updateStructureItem } from './structure-slice';
import { reconcileSpaceWalls } from './structure-thunks';

const RECONCILE_FIELDS = [
  'position',
  'vertices',
  'width',
  'length',
  'conditioned'
] as const;

type StructureStateSlice = { structure?: { structure?: LevelType[] } };

function structureFromState(state: unknown): LevelType[] {
  return (state as StructureStateSlice).structure?.structure ?? [];
}

function requestsForUpdatedItem(
  action: UnknownAction,
  previousStructure: LevelType[]
): SpaceWallReconcileRequestType[] {
  if (!updateStructureItem.match(action)) {
    return [];
  }
  const item = action.payload;
  if (!item?.uniqueId || !RECONCILE_FIELDS.some((field) => field in item)) {
    return [];
  }
  return wallReconcileRequestsFor(previousStructure, [item.uniqueId]);
}

export const structureReconcileMiddleware: Middleware =
  (store) => (next) => (action) => {
    const previousStructure = structureFromState(store.getState());
    const result = next(action);

    const requests = reconcileSpaceWallsRequested.match(action)
      ? action.payload
      : requestsForUpdatedItem(action as UnknownAction, previousStructure);

    if (requests.length > 0) {
      store.dispatch(
        reconcileSpaceWalls({ requests }) as unknown as UnknownAction
      );
    }

    return result;
  };
